<template>
  <div>
      <h2>我的资料</h2>
  </div>
</template>

<script>
export default {
    name:'Material'
}
</script>

<style scoped>

</style>